/**
 * @Description :
 * This reusable React component provides a drag-and-drop file upload interface using `react-dropzone`.
 * 
 * Features:
 *  - Accepts specific file types (`acceptedFileTypes`) defined via props or uses default types.
 *  - Restricts uploads to a maximum number of files (`maxFiles`, default is 10).
 *  - Filters out unsupported file types and dispatches error messages for them using Redux.
 *  - Displays a list of selected file names once files are dropped.
 * 
 * Props:
 *  - files: Array of currently selected files to display
 *  - title: Custom label for the uploader (defaults to "Attachments")
 *  - fileHandler: Callback function to handle valid uploaded files
 *  - acceptedFileTypes: Allowed MIME types for uploaded files (defaults to `defaultFileTypes`)
 *  - maxFiles: Maximum number of files allowed for upload
 */
import React from 'react'
import { useDropzone } from 'react-dropzone'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import { errorSnackBar } from "./../../actions/common.action";
import { useDispatch } from 'react-redux';
import { defaultFileTypes } from '../../util/validators/file';
/**
 * @Component : FileUploader
 * @Modified  : CTBL-333: Fixed validation issues in supplier and contractor bulk import process
 * 
 * @Description :
 * This reusable React component provides a drag-and-drop file upload interface using `react-dropzone`.
 * 
 * Features:
 *  - Accepts specific file types (`acceptedFileTypes`) defined via props or uses default types.
 *  - Restricts uploads to a maximum number of files (`maxFiles`, default is 10).
 *  - Filters out unsupported file types and dispatches error messages for them using Redux.
 *  - Displays a list of selected file names once files are dropped.
 * 
 * Props:
 *  - files: Array of currently selected files to display
 *  - title: Custom label for the uploader (defaults to "Attachments")
 *  - fileHandler: Callback function to handle valid uploaded files
 *  - acceptedFileTypes: Allowed MIME types for uploaded files (defaults to `defaultFileTypes`)
 *  - maxFiles: Maximum number of files allowed for upload
 */

export default function FileUplaoder({ files, title, fileHandler, acceptedFileTypes = defaultFileTypes, maxFiles = 10, ...props }) {

  const dispatch = useDispatch()

  const onDrop = React.useCallback(acceptedFiles => {
    let valid = acceptedFiles.map(file => {
      if (acceptedFileTypes.includes(file.type)) {
        return file
      } else {
        dispatch(errorSnackBar(`This file is invalid - ${file.name}. Not supported this extension.`))
      }
    }).filter(item => item)

    fileHandler(valid)
  }, [fileHandler])

  const { getRootProps, getInputProps } = useDropzone({ maxFiles, onDrop, accept: acceptedFileTypes })

  return (
    <section className='container'>
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} data-cy={props['data-cy']}/>
        <p className='attachmentText'><AttachFileIcon /> {title || 'Attachments'}</p>
        {files && files.length >= 1 && files.map((file, index) => (
          <span key={index}>
            <span>{file.name}</span>
          </span>
        ))}
      </div>

    </section>
  )
}
